import React from "react";
import {injectIntl} from "react-intl";

const _SecondaryHeading = ({text, className, intl}) => (
    <h2 className={className}>{intl.formatMessage({id: text})}</h2>
);

export default injectIntl(_SecondaryHeading);